class RequestInterceptor {
    constructor() {
        this.requestInterceptors = [];
        this.responseInterceptors = [];
    }

    addRequestInterceptor(interceptor) {
        this.requestInterceptors.push(interceptor);
    }

    addResponseInterceptor(interceptor) {
        this.responseInterceptors.push(interceptor);
    }

    async handleRequest(url, options) {
        let modifiedOptions = { ...options };

        for (const interceptor of this.requestInterceptors) {
            modifiedOptions = await interceptor(url, modifiedOptions);
        }

        return modifiedOptions;
    }

    async handleResponse(response) {
        let modifiedResponse = response;

        for (const interceptor of this.responseInterceptors) {
            modifiedResponse = await interceptor(modifiedResponse);
        }

        return modifiedResponse;
    }

    async request(method, url, body = null, options = {}) {
        try {
            const modifiedOptions = await this.handleRequest(url, {
                ...options,
                method: method,
                body: body ? JSON.stringify(body) : null,
                headers: {
                    'Content-Type': 'application/json',
                    ...(options.headers || {})
                }
            });

            let response = await fetch(url, modifiedOptions);

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            response = await this.handleResponse(response);
            return response.json();
        } catch (error) {
            console.error(`${method} request error:`, error);
            throw error;
        }
    }

    async get(url, options = {}) {
        return this.request('GET', url, null, options);
    }

    async post(url, body, options = {}) {
        return this.request('POST', url, body, options);
    }

    async put(url, body, options = {}) {
        return this.request('PUT', url, body, options);
    }

    async delete(url, options = {}) {
        return this.request('DELETE', url, null, options);
    }
}

// 创建全局实例,附加到 window 对象上
window.interceptor = new RequestInterceptor();

window.interceptor.addRequestInterceptor(async (url, options) => {
    options.headers = {
        ...options.headers,
        'Authorization': 'Bearer token'
    };
    return options;
});

window.interceptor.addResponseInterceptor(async (response) => {
    return response;
});
